import React from "react";
import Strings from "../../../config/Strings";
import './Purchase.scss';
import './PurchasePage.scss';


export default function PurchaseError() {
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get("code")

    document.title = Strings.TICKET_REDEMPTION_REDEMPTION_BROWSER_TAB;
    window.scrollTo(0, 0);


    //Rendering
    return (
        <div className="purchase-page standalone">
            <h1 className="purchase-page-title">{Strings.PURCHASE_ERROR_TITLE}</h1>
            <div className="purchase-page-info" dangerouslySetInnerHTML={{__html: code != null ? Strings.PURCHASE_ERROR_INFO_WITH_CODE.replace("{0}", "Fehlercode " + code) : Strings.PURCHASE_ERROR_INFO}} />
        </div>
    );
}